import { CultureInfo } from '@/utils/localization';
import { Profile, Project, User, ItemCategory, ProfileInfo, FrontEndConfiguration, ProjectTerms } from '@/types';
import { MenuMode } from '@ygtechnologies/rubus-ui';

export interface IGlobalReducer {
    readonly user: User | null;
    readonly activeProfile: Profile | null;
    readonly activeProject: Project | null;
    readonly itemCategories: ItemCategory[];
    readonly currentCulture: CultureInfo | null;
    readonly profiles: ProfileInfo[] | null;
    readonly windowWidth: number;
    readonly configuration: FrontEndConfiguration | null;
    readonly canScroll: boolean;
    readonly terms: ProjectTerms | null;
    readonly sidebarMode: MenuMode;
}

const initialState: IGlobalReducer = {
    user: null,
    profiles: null,
    activeProfile: null,
    activeProject: null,
    itemCategories: [],
    currentCulture: null,
    windowWidth: window.innerWidth,
    configuration: null,
    canScroll: true,
    terms: null,
    sidebarMode: 'auto',
};

const global = (state = initialState, action): IGlobalReducer => {
    switch (action.type) {
        case 'SET_GLOBAL_USER':
            return { ...state, user: action.data };
        case 'SET_GLOBAL_PROFILES':
            return { ...state, profiles: action.data };
        case 'SET_GLOBAL_ACTIVE_PROFILE':
            return { ...state, activeProfile: action.data };
        case 'SET_GLOBAL_ACTIVE_PROJECT':
            return { ...state, activeProject: action.data };
        case 'SET_GLOBAL_CATEGORIES':
            return { ...state, itemCategories: action.data };
        case 'SET_GLOBAL_CURRENT_CULTURE':
            return { ...state, currentCulture: action.data };
        case 'SET_WINDOW_WIDTH':
            return { ...state, windowWidth: action.data };
        case 'SET_GLOBAL_CONFIGURATION':
            return { ...state, configuration: action.data };
        case 'SET_GLOBAL_CAN_SCROLL':
            return { ...state, canScroll: action.data };
        case 'SET_GLOBAL_SIDEBAR_MODE':
            return { ...state, sidebarMode: action.data };
        default:
            return state;
    }
};

export default global;
